import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from 'vuex-persistedstate';
import clinic from './clinic';
import navigation from './navigation';
import permission from './permission';
import chat from './chat';
import reception from  './reception';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth: require('./auth').default,
    admin: require('./admin').default,
    videochat: require('./videochat').default,
    clinic,
    navigation,
    permission,
    chat,
    reception,
  },
  plugins: [
    // createPersistedState({ storage: window.sessionStorage })
  ]
});

export default store;
